export const ADDRESS_REGION_CHANGE_ERROR =
  'An account cannot move into or out of the United States by changing its address.';

export function isAddressCountryAllowed(accountCountry?: string | null, candidateCountry?: string | null): boolean {
  if (!accountCountry || !candidateCountry) return true;

  return (accountCountry.toUpperCase() === 'US') === (candidateCountry.toUpperCase() === 'US');
}
